import { combineReducers } from "redux";

import { SET_EXERCICE } from "../actions/exerciceAction";

import agents from "./agentReducer";
import caution from "./cautionReducer";
import codesCouleurs from "./codeCouleurReducer";
import champsPersos from "./champPersoReducer";
import champsPersosGroupes from "./champPersoGroupeReducer";
import comptes from "./compteReducer";
import demandes from "./demandeReducer";
import demandesLocataires from "./demandesLocataireReducer";
import documents from "./documentReducer";
import ecritures from "./ecritureReducer";
import equipements from "./equipementReducer";
import etapes from "./etapeReducer";
import etapesTemplates from "./etapeTemplateReducer";
import evenements from "./evenementReducer";
import exercice from "./exerciceReducer";
import fraisAgence from "./fraisAgenceReducer";
import groupes from "./groupeReducer";
import immeubles from "./immeubleReducer";
import journals from "./journalReducer";
import langues from "./langueReducer";
import locataires from "./locataireReducer";
import locations from "./locationReducer";
import lots from "./lotReducer";
import menages from "./menageReducer";
import parametre from "./parametreReducer";
import parcoursClients from "./parcoursClientReducer";
import pieces from "./pieceReducer";
import proprietaires from "./proprietaireReducer";
import provenances from "./provenanceReducer";
import qualites from "./qualiteReducer";
import quittances from "./quittanceReducer";
import quittancesLignes from "./quittanceLigneReducer";
import rapprochementsBancaires from "./rapprochementBancaireReducer";
import reglements from "./reglementReducer";
import renduAs from "./renduReducer";
import renduAsHistorique from "./renduAHistoriqueReducer";
import requetes from "./requeteReducer";
import requetesLots from "./requeteLotReducer";
import rentalPeriods from "./RentalPeriodReducer"; // FRED
import bookings from "./BookingReducer"; // FRED
import rubriques from "./rubriqueReducer";
import societes from "./societeReducer";
import tags from "./tagReducer";
import templates from "./templateReducer";
import templatesLangues from "./templateLangueReducer";
import typesEmails from "./typeEmailReducer";
import typesLots from "./typeLotReducer";
import typesPaiements from "./typePaiementReducer";
import tree from "./treeReducer";
import utilisateur from "./utilisateurReducer";
import words from "./wordReducer";

const appReducer = combineReducers({
  agents,
  caution,
  codesCouleurs,
  champsPersos,
  champsPersosGroupes,
  comptes,
  demandes,
  demandesLocataires,
  documents,
  ecritures,
  equipements,
  etapes,
  etapesTemplates,
  evenements,
  exercice,
  fraisAgence,
  groupes,
  immeubles,
  journals,
  langues,
  locataires,
  locations,
  lots,
  menages,
  parametre,
  parcoursClients,
  pieces,
  proprietaires,
  provenances,
  qualites,
  quittances,
  quittancesLignes,
  rapprochementsBancaires,
  reglements,
  requetes,
  requetesLots,
  rentalPeriods, // FRED
  bookings, // FRED
  renduAs,
  renduAsHistorique,
  rubriques,
  societes,
  typesEmails,
  typesLots,
  typesPaiements,
  tags,
  templates,
  templatesLangues,
  tree,
  utilisateur,
  words,
});

export default function rootReducer(state, action) {
  // Changement d'exercice : retour à l'état de démarrage, seuls la session et l'exercice survivent.
  // Les slices absentes reçoivent undefined et reprennent leur initialState.
  if (action.type === SET_EXERCICE) {
    const { utilisateur, exercice } = state;
    return appReducer({ utilisateur, exercice }, action);
  }
  return appReducer(state, action);
}
